<template>
  <transition>
    <div
      v-if="isVisible"
      class="environment-info"
      aria-hidden="true"
      @dblclick="$emit('hide')"
    >
      <span v-if="versionNo"><b>Version:</b> {{ versionNo }}</span>
      <br v-if="versionNo && environment">
      <span v-if="environment"><b>Environment:</b> {{ environment }}</span>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'EnvironmentInfo',
  props: {
    versionNo: {
      type: String,
      default: ''
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    environment: {
      type: String,
      default: ''  
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

  .environment-info {
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 500;
    font-size: 16px;
    line-height: 1.5;
    margin: 15px;
    padding: 16px;
    border-radius: 5px;
    box-shadow: 0 10px 10px rgba(black, 0.1);
    background-color: $ads-white;
    color: $ads-dark-80;
   }
</style>